// Provenance: repo:tds-reconciliation-portal:frontend/src/components/RefreshButton.tsx
// (ADR-0005) — restyled on the estate tokens (ADR-0010).
import { RefreshCw } from 'lucide-react'
import { useIsFetching, useQueryClient } from '@tanstack/react-query'

import { Btn } from './Modal'

/** Re-read what is on screen. Never re-run the reconciliation.
 *
 *  Two people work a client at once — a preparer matching while a reviewer
 *  approves — and the only alternatives are reloading the browser or starting
 *  a NEW RUN, which is minutes of engine time and a fresh set of rows.
 *  Invalidating rather than refetching means only the queries actually
 *  mounted go and ask again. */

/** What Reconciliation keeps current BY ITSELF, on window focus (the hooks
 *  set `refetchOnWindowFocus`). Deliberately NOT the whole old list:
 *  `timing`, `credit-at-risk` and `match-suggestions` each full-scan the run
 *  and change only when a run does. */
export const RECONCILIATION_LIVE_KEYS = [
  'reconciliation', 'resolution-progress', 'difference', 'difference-summary',
  'difference-parties', 'cleared',
]

/** The full-scan queries, listed so the exclusion above is a stated decision
 *  rather than an omission somebody has to notice. */
export const RECONCILIATION_HEAVY_KEYS = [
  'match-suggestions', 'timing', 'credit-at-risk',
]

export const REPORTS_REFRESH_KEYS = [
  'reports-summary', 'reconciliation', 'parties', 'documents', 'runs',
]

export function RefreshButton({ keys, label = 'Refresh' }: {
  /** query-key prefixes to invalidate */
  keys: string[]
  label?: string
}) {
  const qc = useQueryClient()
  const fetching = useIsFetching() > 0
  return (
    <Btn
      size="xs"
      title="Re-read the latest data. This does not re-run the reconciliation."
      loading={fetching}
      onClick={() => {
        for (const k of keys) void qc.invalidateQueries({ queryKey: [k] })
      }}
    >
      <RefreshCw size={14} /> {label}
    </Btn>
  )
}
